const BALL_WIDTH = 25;

export class Basketball {
  box: HTMLElement;
  ball: SVGSVGElement;

  posX = 0;
  velocityX = 90;
  time = 0;
  lastTime?: number;

  bounceHeight = 50;
  bounceFrequency = 1.2;
  radius = BALL_WIDTH / 2;
  rotation = 0;
  rotationRate = 0.18;

  constructor() {
    this.box = document.querySelector("[data-basketball]") as HTMLElement;
    this.ball = this.box.children[0] as SVGSVGElement;

    this.init();
  }

  init() {
    requestAnimationFrame(this.animateBall);
  }

  animateBall = (timeStamp: number) => {
    if (!this.lastTime) {
      this.lastTime = timeStamp;
    }

    const dt = (timeStamp - this.lastTime) / 1000;
    this.lastTime = timeStamp;
    this.time += dt;

    this.posX += this.velocityX * dt;
    const maxX = this.box.clientWidth - BALL_WIDTH;

    if (this.posX <= 0) {
      this.posX = 0;
      this.velocityX = Math.abs(this.velocityX);
    } else if (this.posX >= maxX) {
      this.posX = maxX;
      this.velocityX = -Math.abs(this.velocityX);
    }

    const phase = this.time * Math.PI * this.bounceFrequency;
    const y = Math.abs(Math.sin(phase)) * this.bounceHeight;

    const degPerPx = 360 / (2 * Math.PI * this.radius);
    this.rotation += this.velocityX * dt * degPerPx * this.rotationRate;

    this.ball.style.transform = `translate(${this.posX}px, -${y}px) rotate(${this.rotation}deg)`;

    requestAnimationFrame(this.animateBall);
  };
}
